module.exports = __webpack_public_path__ + "static/media/image_female_active.91751f0f.svg";